module.exports = __webpack_public_path__ + "static/island-logo-36352e16a51fb2767fbdbe39d8441450.png";